import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FatorEcg } from 'src/app/model/tranche.model';

@Component({
    selector: 'app-modal-fator-ecg',
    templateUrl: './modal-fator-ecg.component.html',
    styleUrls: ['./modal-fator-ecg.component.scss'],
    standalone: false
})

//Modal de fatores de ecg que abre a partir de outro modal 

export class ModalFatorEcgComponent implements OnInit {

  @Input() fatoresEcg: FatorEcg[];
  @Input() fatorEdicao: FatorEcg;
  
  public fatorEcg: FatorEcg = new FatorEcg();
  public todosCamposPreenchidos: boolean = false;
  public ultimoFatorEcg: FatorEcg = new FatorEcg();

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    if (this.inclusao) {
      this.pegarUltimoFatorEcg();
    } else {
      this.fatorEcg = new FatorEcg();
      this.fatorEcg.id = this.fatorEdicao.id;
      this.fatorEcg.quantidadeMesesPrazoTotalInicial = Number(this.fatorEdicao.quantidadeMesesPrazoTotalInicial);
      this.fatorEcg.quantidadeMesesPrazoTotalFinal = Number(this.fatorEdicao.quantidadeMesesPrazoTotalFinal);
      this.fatorEcg.valorFatorEcg = Number(this.fatorEdicao.valorFatorEcg);
      
      this.todosCamposPreenchidos = true;
    }
  }

  public salvar(): void {
    this.activeModal.close({botao: 'salvar', valor: this.fatorEcg, inclusao: this.inclusao});
  }

  public cancelar(): void {
    this.activeModal.close({botao: 'cancelar', valor: null});
  }

  public fechar(): void {
    this.activeModal.close({botao: 'fechar', valor: null});
  }

  public verificarCamposPreenchidos(): void {
    this.todosCamposPreenchidos = (
         this.fatorEcg.quantidadeMesesPrazoTotalInicial != null
      && this.fatorEcg.quantidadeMesesPrazoTotalFinal != null
      && this.fatorEcg.quantidadeMesesPrazoTotalFinal >= this.fatorEcg.quantidadeMesesPrazoTotalInicial
      && this.fatorEcg.valorFatorEcg != null
      && this.fatorEcg.valorFatorEcg > 0.00
      );
  }

  public pegarUltimoFatorEcg(): void { //criada para pegar o último fator da lista de Fatores de ECG (que vem da vigência) e sugerir valores pro usuário
    if(this.fatoresEcg.length > 0) {
      this.ultimoFatorEcg = this.fatoresEcg[this.fatoresEcg.length - 1];
      this.fatorEcg.quantidadeMesesPrazoTotalInicial = +this.ultimoFatorEcg.quantidadeMesesPrazoTotalFinal + 1;
    } else {
      this.fatorEcg.quantidadeMesesPrazoTotalInicial = +0;
    }
  }

  get inclusao() {
    return this.fatorEdicao == null;
  }

}
